import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createTextVNode(_toDisplayString(_ctx.description) + " ", 1),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.date(this.range.start)) + " - " + _toDisplayString(_ctx.$filters.date(this.range.end)), 1)
    ], 512), [
      [_vShow, _ctx.isCustom]
    ])
  ]))
}